<template>
  <div class="example-wrapper">
    <div class="example-header">
      <vs-row vs-w="12" class="mb-5">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="1"
          vs-sm="4"
          vs-xs="12"
        >
          <slot name="refresh-button"> </slot>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="1"
          vs-sm="4"
          vs-xs="12"
        >
        <slot name="sort-button"> </slot>

          <!-- <vs-button class="ml-5" @click="exportTableData">Export</vs-button> -->
        </vs-col>
      </vs-row>
    </div>

    <ag-grid-vue
    @showStatusPopUp="showStatusPopUp(data)"
    @showTagPopUp="showTagPopUp(data)"
    @editSalesDeveloperContact="editSalesDeveloperContact(contact)"
    @editSalesDeveloperAccount="editSalesDeveloperAccount(account)"
    :paginationPageSizeSelector="paginationPageSizeSelector"
    :paginationPageSize="paginationPageSize"
      @sendSelectionToActualPage="sendSelectionToActualPage"
      suppressSizeToFit="true"
      ref="dataGrid"
      :accentedSort="true"
      :gridOptions="gridOptions"
      class="ag-theme-quartz"
      :columnDefs="columnDefs"
      :rowData="rowData"
      domLayout="autoHeight"
      :rowSelection="rowSelection"
      colResizeDefault="shift"
      @grid-ready="onGridReady"
      @model-updated="onModelUpdated"
      @cell-clicked="onCellClicked"
      @cell-double-clicked="onCellDoubleClicked"
      @cell-context-menu="onCellContextMenu"
      @cell-value-changed="onCellValueChanged"
      @cell-focused="onCellFocused"
      @filter-changed="onFilterApply($event)"
      @row-selected="onRowSelected($event)"
      @selection-changed="onSelectionChanged"
      @filter-modified="onFilterModified($event)"
      @virtual-row-removed="onVirtualRowRemoved"
      @row-clicked="onRowClicked($event)"
      @column-everything-changed="onColumnEvent"
      @column-row-group-changed="onColumnEvent"
      @column-value-Changed="onColumnEvent"
      @column-moved="onColumnEvent"
      @column-visible="onColumnEvent"
      @column-group-Opened="onColumnEvent"
      @column-resized="onColumnEvent"
      @column-pinned-count-changed="onColumnEvent"
      :pagination="true"
      :suppressRowClickSelection="true"
      :sideBar="sideBar"
      :animateRows="true"
      :defaultColDef="{
        sortable: true,
        resizable: true,
        filter: true,
        // allow every column to be aggregated
        enableValue: false,
        // allow every column to be grouped
        enableRowGroup: false,
        // allow every column to be pivoted
        enablePivot: false
      }"
    >
    </ag-grid-vue>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import axios from "@/axios.js";
import defineAbilitiesFor from "@/config/abilities";
import CellRendererActions from "@/components/CellRendererActions.vue";
import CellRendererPopUpActions from "@/components/CellRendererPopUpActions.vue";
import CellRendererButtons from "@/components/CellRendererButtons.vue";
import "ag-grid-community/styles//ag-grid.css";
import "ag-grid-community/styles//ag-theme-quartz.css";
import { LicenseManager } from  'ag-grid-enterprise'
LicenseManager.setLicenseKey("Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-057721}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Elomark_Limited}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{elomarkportal}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{elomarkportal}_need_to_be_licensed___{elomarkportal}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{4_April_2025}____[v3]_[0102]_MTc0MzcyMTIwMDAwMA==1137b2497a880d7e0eb4ecc86fb921b0")
export default {
  name: "DataGrid",
  props: {
    columnDefs: {
      type: Array,
      default: ""
    },
    rowSelection: {
      type: String,
      default: "multiple"
    },
    rowData: {
      type: Array,
      default: ""
    },
    selected_account: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data: () => ({
    all_selected_rows: [],
    rowModelType: null,
    // AgGrid
    gridApi: null,
    gridOptions: {},
    sideBar: {
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
          minWidth: 225,
          maxWidth: 225,
          width: 225,
          toolPanel: "agColumnsToolPanel"
        },
        {
          id: "filters",
          labelDefault: "Filters",
          labelKey: "filters",
          iconKey: "filter",
          toolPanel: "agFiltersToolPanel",
          minWidth: 180,
          maxWidth: 400,
          width: 250
        }
      ],
      position: "right",
      defaultToolPanel: ""
    },
    context: null,
    abilities: null,
    sdAccountClickEventAccId: null,
    sdContactClickEventConId: null
  }),
  components: {
    CellRendererActions,
    CellRendererPopUpActions,
    AgGridVue,
    CellRendererButtons
  },
  watch: {},
  methods: {
    goToEditSalesDeveloperOpportunities (account) {
      this.$emit('goToEditSalesDeveloperOpportunities', account)
    },
    showTagPopUp (account) {
      this.$emit('showTagPopUp', account)
    },
    showStatusPopUp (data) {
      this.$emit('showStatusPopUp', data)
    },
    editSalesDeveloperAccount (account) {
      this.$emit('editSalesDeveloperAccount', account)
    },
    editSalesDeveloperContact (contact) {
      this.$emit('editSalesDeveloperContact', contact)
    },
    sendSelectionToActualPage() {
      this.$emit("sendSelectionToActualPage", this.all_selected_rows);
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    onPageSizeChanged(newPageSize) {
      var value = document.getElementById("page-size").value;
      this.gridApi.paginationSetPageSize(Number(value));
    },
    onModelUpdated() {
      // console.log("onModelUpdated");
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      params.api.setGridOption(this.rowData);
    },
    onCellClicked (event) {
      if ((event.type = 'cellClicked')) {
        event.node.hightlight = '1'
        event.node.setSelected(true)

       
          let account_id = event.data.account_id

          if (event.node.highlighted == '1') {
            let selected = this.gridApi.getSelectedNodes()
            _.each(selected, function (node) {
              let data = node.data
              if (data.account_id != account_id) {
                node.hightlight = null
                node.setSelected(false)
              } else {
                node.hightlight = '1'
                node.setSelected(true)
              }
            })    
          } else {
            event.node.setSelected(true)

            this.gridApi.forEachNode(function (node) {
              node.highlighted = null
            })

            event.node.highlighted = '1'
          }

          if (
            this.sdAccountClickEventAccId != account_id &&
            this.sdContactClickEventConId == null
          ) {
            this.sdAccountClickEventAccId = account_id
            this.$emit('showContactsWithAccountID', account_id)
          } else {
            this.sdAccountClickEventAccId = null
            this.$emit('showContactsWithAccountID', null)

            event.node.setSelected(false)
            event.node.highlighted = null

          }
     

        if (event.colDef.field == 'client-user-live') {
          this.showClientUserLive(event.data)
          // alert("client-user-live")
        }

        if (event.colDef.field == 'client-user-insights') {
          this.showClientUserInsights(event.data)
        }

        if (event.colDef.field == 'contact-campaign-status') {
          this.showCampaignStatusPopup(event.data)
        }

        if (event.colDef.field == 'new-selected_accounts-for-campaign') {
          this.showCampaignStatusPopup(event.data)
        }
      }
    },
    onCellValueChanged(event) {
      // console.log(
      //   "onCellValueChanged: " + event.oldValue + " to " + event.newValue
      // );
    },
    onCellDoubleClicked(event) {
      this.showCampaignStatusPopup(event.data);
    },
    onCellContextMenu(event) {
      // console.log(
      //   "onCellContextMenu: " + event.rowIndex + " " + event.colDef.field
      // );
    },
    onCellFocused(event) {
      // console.log(
      //   "onCellFocused: (" + event.rowIndex + "," + event.colIndex + ")"
      // );
    },
    // taking out, as when we 'select all', it prints to much to the console!!
    // eslint-disable-next-line
    onRowSelected(event) {
      // alert("sdfsdfsdf")
      // console.log(this.gridOptions.api.getDisplayedRowCount());
      // console.log(this.gridOptions.api.getSelectedRows())
      // this.gridOptions.api.selectAll()
    },
    sendSelectionToActualPage() {
      this.$emit("sendSelectionToActualPage", this.all_selected_rows);
    },
    onSelectionChanged() {
      this.all_selected_rows = this.gridApi.getSelectedRows();

      // console.log(this.all_selected_rows);
      this.sendSelectionToActualPage();
    },
    onFilterModified(event) {
      // console.log(event , "onFilterModified");
    },
    onFilterApply(event) {
      // this.onSDAccountFilterModified(event);
      // console.log(event)
    },
    // onSDAccountFilterModified(event) {
    //   this.$emit("onSDQCAccountFilterModified", event);
    // },
    // eslint-disable-next-line
    onVirtualRowRemoved(event) {
      // because this event gets fired LOTS of times, we don't print it to the
      // console. if you want to see it, just uncomment out this line
      // console.log('onVirtualRowRemoved: ' + event.rowIndex);
    },
    onRowClicked(event) {
      // console.log("onRowClicked: " + event);
    },
    onQuickFilterChanged(event) {
      this.gridOptions.api.setQuickFilter(event.target.value);
    },
    // here we use one generic event to handle all the column type events.
    // the method just prints the event name
    onColumnEvent(event) {
      // console.log("onColumnEvent: " + event);
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    if (this.$vs.rtl) {
      const header = this.$refs.enrichAccountGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left =
        "-" + String(Number(header.style.transform.slice(11, -3)) + 9) + "px";
    }
  },
  beforeMount() {
    this.cacheBlockSize = 10;
    this.context = { componentParent: this };
    this.paginationPageSize = 10
    this.paginationPageSizeSelector = [10, 20, 50, 100];
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
  }
};
</script>
<style lang="scss">

</style>
